import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

export const lossesSlice = createApi({
  reducerPath: 'losses',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const publicEndpoints = ['getEnemyLosses'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ['Losses'],
  endpoints: (builder) => ({
    getEnemyLosses: builder.query<IAnyResponse, void>({
      query: (payload) => ({
        url: `/enemy-loss`,
        method: 'GET'
      })
    })
  })
});

export const { useGetEnemyLossesQuery } = lossesSlice;
